import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../../../../../styles/common/mixins/helpers.styled.js";
export const PanelAccommodationPanelBodyMobile = styled.div.withConfig({
    displayName: "styled__PanelAccommodationPanelBodyMobile",
    componentId: "sc-c0c9ce4f-0"
})`
	${FlexMixin({
    direction: 'column'
})}
	overflow-y: auto;
	position: relative;
`;
export const PanelAccommodationHeader = styled.div.withConfig({
    displayName: "styled__PanelAccommodationHeader",
    componentId: "sc-c0c9ce4f-1"
})`
	${FlexMixin({
    justify: 'space-between'
})}
	border-bottom: 1px solid ${({ theme  })=>theme.colors.grays.light};
	padding: 16px;

	& > p {
		${FontMixin({
    size: 'base',
    weight: 'bold',
    height: 'base'
})}
		color: ${({ theme  })=>theme.colors.grays.darker};
		margin: 0;
	}
`;
export const PanelAccommodationRoomHeader = styled.div.withConfig({
    displayName: "styled__PanelAccommodationRoomHeader",
    componentId: "sc-c0c9ce4f-2"
})`
	${FlexMixin({
    justify: 'space-between',
    align: 'center'
})}
	margin-bottom: 8px;

	& > p {
		color: ${({ theme  })=>theme.colors.grays.darker};
		${FontMixin({
    size: 'large',
    weight: 'medium',
    height: 'large'
})}
	}
`;
export const PanelAccommodationRoomHeaderDelete = styled.div.withConfig({
    displayName: "styled__PanelAccommodationRoomHeaderDelete",
    componentId: "sc-c0c9ce4f-3"
})`
	${FlexMixin({
    align: 'center',
    justify: 'center'
})}
	background-color: transparent;
	color: ${({ theme  })=>theme.colors.grays.base};
	text-transform: uppercase;
	cursor: pointer;
`;
export const PanelAccommodationPortalsMobile = styled.div.withConfig({
    displayName: "styled__PanelAccommodationPortalsMobile",
    componentId: "sc-c0c9ce4f-4"
})`
	position: absolute;
	top: 0;
	left: 0;
	z-index: ${({ theme  })=>theme.zIndex.highest};
`;
export const PanelAccommodationRoomsMobile = styled.div.withConfig({
    displayName: "styled__PanelAccommodationRoomsMobile",
    componentId: "sc-c0c9ce4f-5"
})`
	margin-top: 12px;
	background-color: ${({ theme  })=>theme.colors.white.base};
	border-bottom: 2px solid ${({ theme  })=>theme.colors.primary.lighter};
	padding: 16px 16px 8px;
`;

//# sourceMappingURL=styled.js.map